<script setup lang="ts">
import type { IconConstant } from '@tpg/grammar-web-icons';

import { GrammarDivider } from '@nora-monorepo/grammar-ui';

import MenuGroup from '#nora-ui/map/components/overlay-menu/primitives/MenuGroup.vue';
import MenuItemRow from '#nora-ui/map/components/overlay-menu/primitives/MenuItemRow.vue';

export interface SimpleLayerItem {
  id: string;
  name: string;
  visible: boolean;
  toggleVisibility: () => void;
}

/**
 * A titled group of plain toggleable layer rows (base maps, map overlays, offline maps).
 * Each of those sections is structurally identical — only the icon, the radio-vs-eye
 * toggle, and the item wrapper class differ — so they share this component.
 */
interface SimpleLayerGroupProps {
  title: string;
  items: SimpleLayerItem[];
  icon?: IconConstant;
  isRadioButton?: boolean;
  itemClass?: string;
}

defineProps<SimpleLayerGroupProps>();
</script>

<template>
  <MenuGroup :title="title">
    <div
      v-for="(menuItem, index) of items"
      :key="menuItem.id"
      :class="itemClass"
    >
      <MenuItemRow
        :icon="icon"
        :title="menuItem.name"
        :visible="menuItem.visible"
        :is-radio-button="isRadioButton"
        :selectable="isRadioButton"
        @visibility-changed="menuItem.toggleVisibility"
        @tpg-select="menuItem.toggleVisibility"
      />

      <GrammarDivider
        v-if="index !== items.length - 1"
        emphasis="low-emphasis"
        class="px-2"
      />
    </div>
  </MenuGroup>
</template>
